<section class="auction-add-vehicle">
  <div class="container-fluid">
    <div class="auction-content-main" *ngIf="attributesList.length">
      <div class="auction-content-header px-4 pt-4 pb-2">
        <h4 class="fs-lg color-ashen-med">Add New</h4>
      </div>
      <div class="auction-content-body p-4">
        <form
          class="auction-add-vehicle__form credential2"
          [formGroup]="addVehicleForm"
          (submit)="addVehicle()"
        >
          <div class="row">
            <div
              formArrayName="attributes"
              class="col-md-4"
              *ngFor="let attribute of attributesList; index as i"
            >
              <div [formGroupName]="i" *ngIf="!indicator">
                <div class="form-group">
                  <label for="" class="credential2__label">{{
                    attribute.field_name
                  }}</label>
                  <ng-container>
                    <input
                      *ngIf="attribute.field_type === 'text'"
                      type="text"
                      name="make"
                      [formControlName]="
                        attribute.field_name ? attribute.field_name : ''
                      "
                      class="credential2__input form-control"
                    />
                    <select
                      *ngIf="attribute.field_type === 'dropdown'"
                      name="rating"
                      [formControlName]="
                        attribute.field_name ? attribute.field_name : ''
                      "
                      class="credential2__select form-control"
                    >
                      <option value="">Select</option>
                      <option
                        [value]="option.value"
                        *ngFor="
                          let option of attribute.options | keyvalue;
                          index as i
                        "
                      >
                        {{ option.value ? option.value : "N/A" }}
                      </option>
                    </select>
                  </ng-container>
                </div>
              </div>

              <div [formGroupName]="i" *ngIf="indicator">
                <div class="form-group">
                  <label for="" class="credential2__label">{{
                    attribute.field_name
                  }}</label>
                  <ng-container>
                    <input
                      *ngIf="attribute.field_type === 'text'"
                      type="text"
                      name="make"
                      [formControlName]="
                        attribute.field_name ? attribute.field_name : ''
                      "
                      class="credential2__input form-control"
                      [class.is-invalid]="
                        submitBtn &&
                        addVehicleForm.controls.attributes['controls'][i][
                          'status'
                        ] === 'INVALID'
                      "
                    />
                    <div *ngIf="submitBtn" class="invalid-feedback">
                      <p
                        *ngIf="
                          attribute.field_type === 'text' &&
                          addVehicleForm.controls.attributes['controls'][i][
                            'status'
                          ] === 'INVALID'
                        "
                      >
                        {{ attribute.field_name }} is required.
                      </p>
                    </div>
                    <select
                      *ngIf="attribute.field_type === 'dropdown'"
                      name="rating"
                      [formControlName]="
                        attribute.field_name ? attribute.field_name : ''
                      "
                      class="credential2__select form-control"
                      [class.is-invalid]="
                        submitBtn &&
                        addVehicleForm.controls.attributes['controls'][i][
                          'status'
                        ] === 'INVALID'
                      "
                    >
                      <option value="">Select</option>
                      <option
                        [value]="option.value"
                        *ngFor="
                          let option of attribute.options | keyvalue;
                          index as i
                        "
                      >
                        {{ option.value ? option.value : "N/A" }}
                      </option>
                    </select>
                    <div *ngIf="submitBtn" class="invalid-feedback">
                      <p
                        *ngIf="
                          attribute.field_type === 'dropdown' &&
                          addVehicleForm.controls.attributes['controls'][i][
                            'status'
                          ] === 'INVALID'
                        "
                      >
                        Please select an option from {{ attribute.field_name }}.
                      </p>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="" class="credential2__label">Location</label>
                <input
                  type="text"
                  name=""
                  formControlName="location"
                  class="credential2__input form-control"
                  [class.is-invalid]="submitBtn && formData['location'].errors"
                />
                <div class="invalid-feedback">
                  <p>Please provide location</p>
                </div>
              </div>
            </div>
          </div>

          <div class="row mx-n2">
            <div class="col-sm-6 col-md-4 col-xl-2 px-2">
              <div class="form-group position-relative">
                <label for="vehicle_1" class="credential__file">
                  <input
                    type="file"
                    accept="image/*"
                    name="vehicle_1"
                    id="vehicle_1"
                    class="form-control d-none"
                    (change)="getProfileImage($event, 1)"
                    multiple
                  />
                  <img src="{{ env }}assets/img/add-image.svg" alt="" />
                </label>
              </div>
            </div>
            <div
              class="col-sm-6 col-md-4 col-xl-2 px-2"
              *ngFor="let images of imageGroup; index as i"
            >
              <div class="form-group position-relative add-user-img">
                <button
                  type="button"
                  class="btn-close close pull-right"
                  aria-label="Close"
                  [swal]="{
                    title: 'Are You Sure?',
                    icon: 'question',
                    showCancelButton: true
                  }"
                  (confirm)="deleteImage()"
                  (dismiss)="handleDismiss($event)"
                  (click)="openModal(images, i)"
                >
                  <span aria-hidden="true" class="visually-hidden"
                    ><ion-icon name="close-outline"></ion-icon
                  ></span>
                </button>
                <label for="vehicle_2"></label>
                <input
                  type="file"
                  name="vehicle_2"
                  id="vehicle_2"
                  class="form-control d-none"
                  (change)="getProfileImage($event, 2)"
                />
                <img
                  [src]="images['image'] ? images['image'] : ''"
                  alt="image"
                />
              </div>
            </div>

            <div class="col-12 px-2">
              <div class="auction-add-vehicle__btnGrp ml-auto">
                <button
                  type="submit"
                  class="btn btn__main curved w-100"
                  [ladda]="laddaLoading"
                >
                  {{ vehicleId ? "UPDATE" : "ADD" }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<ng-template #template>
  <div class="modal-body">
    <div class="modal-content-details">
      <h2 class="confirmText">Are You Sure?</h2>
      <div class="btnGroup">
        <button
          type="button"
          class="btn btn-delete mx-2"
          (click)="deleteImage()"
        >
          Delete
        </button>
        <button
          type="button"
          class="btn btn-cancel mx-2"
          (click)="modalRef?.hide()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>

<app-loader *ngIf="loading"></app-loader>
